import styled from "styled-components";

export const ContentContainer = styled.div`
    margin-bottom: 4rem;
    margin-left: 3rem;
    margin-right: 3rem;
    min-height: 480px;
`;
